import React, { forwardRef, ReactNode } from 'react';
import {
  Divider as ChakraDivider,
  DividerProps,
  useStyleConfig,
} from '@chakra-ui/react';

type Variants = `small` | `solid` | `dashed`;

interface Props extends DividerProps {
  children?: ReactNode;
  variant?: Variants;
}

export const Divider = forwardRef<HTMLHRElement, Props>(
  ({ children, variant, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`Divider`, { variant });

    return (
      <ChakraDivider ref={ref} __css={styles} {...props}>
        {children}
      </ChakraDivider>
    );
  }
);
export type { Props as DividerProps };
